import React, { useState, useEffect } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import PersonalInfo from "./PersonalInfo";
import EducationInfo from "./EducationInfo";
import ExperienceInfo from "./ExperienceInfo";
import TrainingCertificate from "./TrainingCertificate";
import ResearchPublication from "./ResearchPublication";
import AdditionalInfo from "./AdditionalInfo";

const UpdateProfile = () => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get("/api/profile")
      .then((res) => setProfileData(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center py-10 text-blue-600">Loading profile...</div>;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      className="p-6 bg-gradient-to-br from-[#B7EAFC] via-[#F0FCFF] to-[#F0FCFF]  rounded-2xl shadow-lg"
    >
      <h1 className="text-3xl font-bold text-[#016C94] mb-6 text-center">Update Profile</h1>

      <Tabs defaultValue="personal" className="w-full text-[#016C94]">
        <TabsList className="flex justify-center bg-white shadow-md rounded-xl mb-8 text-[#1A2B63]">
          <TabsTrigger value="personal">Personal Information</TabsTrigger>
          <TabsTrigger value="education">Education</TabsTrigger>
          <TabsTrigger value="experience">Experience</TabsTrigger>
          <TabsTrigger value="training">Training & Certificate</TabsTrigger>
          <TabsTrigger value="research">Research & Publication</TabsTrigger>
          <TabsTrigger value="additional">Additional Information</TabsTrigger>
        </TabsList>

        <TabsContent value="personal">
          <PersonalInfo data={profileData.personalInfo} />
        </TabsContent>

        <TabsContent value="education">
          <EducationInfo data={profileData.education} />
        </TabsContent>

        <TabsContent value="experience">
          <ExperienceInfo data={profileData.experience} />
        </TabsContent>

        <TabsContent value="training">
          <TrainingCertificate data={profileData.training} />
        </TabsContent>

        <TabsContent value="research">
          <ResearchPublication data={profileData.research} />
        </TabsContent>

        <TabsContent value="additional">
          <AdditionalInfo data={profileData.additional} />
        </TabsContent>
      </Tabs>
    </motion.div>
  );
};

export default UpdateProfile;
